import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { FixedSizeList as List } from 'react-window';
import './CompanyAutoComplete.css';

class SerialNumberSelect extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: [],
      isDropdownOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterSerialNumbers = (value) => {
    const inputValue = value.trim().toLowerCase();
    const { companies } = this.props;
    const filteredSuggestions = companies.filter((company) =>
      company.serialNumber.toLowerCase().includes(inputValue)
    );

    this.setState({ isDropdownOpen: filteredSuggestions.length > 0 });

    return filteredSuggestions;
  };

  getCompanyValue = company => company.serialNumber;

  renderSuggestion = ({ index, style }) => {
    const { suggestions } = this.state;
    const company = suggestions[index];

    return (
      <div
        style={{ ...style, padding: '8px', cursor: 'pointer', backgroundColor: '#f8f9fa' }}
        key={company?.serialNumber}
        className="suggestion-item"
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#e9ecef')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#f8f9fa')}
        onClick={() => this.onCompanySelected(null, { suggestion: company, suggestionValue: company.serialNumber })}
      >
        {company?.serialNumber}
      </div>
    );
  };

  onChange = (event, { newValue }) => {
    this.props.typeTextChange(newValue);
    if (newValue === '') {
      this.props.onChange({ name: 'company', value: null, suggestion: null });
    }
    this.setState({ searchTerm: newValue });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.filterSerialNumbers(value) });
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [], isDropdownOpen: false });
  };

  onCompanySelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'serialNumber', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
    this.setState({ searchTerm: suggestionValue, isDropdownOpen: false });
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { companies, userAutocomplete } = this.props;
      let suggestion = !userAutocomplete
        ? companies.filter(item => item.serialNumber === e.currentTarget.value)
        : companies.filter(item => item._id === e.currentTarget.value);
      this.props.onChange({
        name: 'serialNumber',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, suggestions, isDropdownOpen } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Serial Number...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'serialNumber',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getCompanyValue}
          renderSuggestionsContainer={({ containerProps }) => (
            <div
              {...containerProps}
              style={{
                maxHeight: isDropdownOpen ? 200 : 0,
                border: isDropdownOpen ? '1px solid #ced4da' : 'none',
                boxShadow: isDropdownOpen ? '0px 4px 6px rgba(0,0,0,0.1)' : 'none',
              }}
              className='virtualization-container'
            >
              {isDropdownOpen && (
                <List
                  height={200}
                  itemCount={suggestions.length}
                  itemSize={40}
                  width={'100%'}
                >
                  {this.renderSuggestion}
                </List>
              )}
            </div>
          )}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onCompanySelected}
        />
      </div>
    );
  }
}

export default SerialNumberSelect;
